import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { backendUrl } from '../../constants';
import { approveActivityAction } from '../../actions/activityLogs';
import { useDispatch } from 'react-redux';
import TimeFormat from '../timeFormat/timeFormat';
import Deletemodel from '../../pages/dashboard/Deletemodel';
import Confirmmodel from './Confirmmodel';

// Helper to render field value based on type
function renderFieldValue(field) {
    const rawValue = field.value;

    if (rawValue === undefined || rawValue === null || rawValue === '') {
        return '-';
    }

    const valueStr = String(rawValue);

    switch (field.type) {
        case 'textarea':
            return (
                <div
                    className="text-break"
                    style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
                >
                    {valueStr}
                </div>
            );

        case 'number':
            return <span>{valueStr}</span>;

        case 'email':
            return (
                <a href={`mailto:${valueStr}`} rel="noreferrer">
                    {valueStr}
                </a>
            );

        case 'date': {
            const d = new Date(valueStr);
            const isValidDate = !isNaN(d.getTime());
            return <span>{isValidDate ? d.toLocaleDateString() : valueStr}</span>;
        }

        case 'select': {
            // If options are present, show label instead of raw value
            if (Array.isArray(field.options) && field.options.length > 0) {
                const matched = field.options.find((opt) => opt.value === rawValue);
                if (matched) {
                    return (
                        <span>
                            {matched.label}{' '}
                            <small className="text-muted">({matched.value})</small>
                        </span>
                    );
                }
            }
            return <span>{valueStr}</span>;
        }

        case 'file': {
            const url = backendUrl + valueStr;
            // strip query string for extension check
            const cleanUrl = url.split('?')[0].toLowerCase();
            const isImage = /\.(jpe?g|png|gif|webp|svg)$/i.test(cleanUrl);

            if (isImage) {
                return (
                    <div>
                        <img
                            src={url}
                            alt={field.label || 'Uploaded file'}
                            style={{
                                maxWidth: '140px',
                                maxHeight: '140px',
                                objectFit: 'cover',
                                borderRadius: 4,
                                border: '1px solid #eee',
                            }}
                        />
                        <div className="mt-1">
                            <a href={url} target="_blank" rel="noreferrer">
                                Open full image
                            </a>
                        </div>
                    </div>
                );
            }

            return (
                <a href={url} target="_blank" rel="noreferrer">
                    Download file
                </a>
            );
        }

        case 'text':
        default:
            return <span>{valueStr}</span>;
    }
}

export default function ViewKycDetails({ show, onClose, pageItem }) {
    const dispatch = useDispatch();
    const [showApprove, setShowApprove] = useState(false);
    const [confirmshow, setConfirmShow] = useState(false);

    const handleSubmit = async (flag) => {
        setConfirmShow(false);
        var payload = {
            type: pageItem.pageType,
            userId: pageItem.user._id,
            flag: flag,
            todoId: pageItem.usertodo?._id,
            activityId: pageItem.id
        };
        await dispatch(approveActivityAction(payload));
        onClose();
    };

    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            size="lg"
        >
            <div className="modal-header pt-2">
                <button
                    type="button"
                    className="btn-close text-dark close-button"
                    onClick={onClose}
                >
                    &nbsp;
                    {/* <span aria-hidden="true">×</span> */}
                </button>
            </div>
            <div className="modal-body">
                {pageItem ? (
                    <>
                        {/* Basic info */}
                        <div className="mb-3">
                            <h5 className="mb-1">{pageItem.title}</h5>
                            <div className="text-muted small">
                                {pageItem?.user?.first_name} {pageItem?.user?.last_name}
                                {pageItem?.user?.email ? ` · ${pageItem.user.email}` : ''}
                            </div>
                            <div className="mt-2">
                                <span className="badge bg-secondary">
                                    {/* {pageItem?.status?.toUpperCase() || '-'} */}
                                </span>
                            </div>
                        </div>

                        {/* Fields (if stored) */}
                        {Array.isArray(pageItem?.usertodo?.fields) && pageItem?.usertodo?.fields.length > 0 && (
                            <div className="todo-detail-fields">
                                <h6 className="mb-2">Fields</h6>
                                {pageItem?.usertodo?.fields.map((field, idx) => (
                                    <div
                                        key={field.key || idx}
                                        className="d-flex flex-column flex-md-row justify-content-between align-items-md-center border rounded p-2 mb-2"
                                    >
                                        <div className="mb-1 mb-md-0">
                                            <div className="fw-semibold">
                                                {field.label}{' '}
                                                {field.required ? (
                                                    <span className="text-danger">*</span>
                                                ) : null}
                                            </div>
                                            <div className="text-muted small">
                                                Key: {field.key} · Type: {field.type}
                                            </div>
                                            {field.placeholder && (
                                                <div className="text-muted small">
                                                    Placeholder: {field.placeholder}
                                                </div>
                                            )}
                                        </div>

                                        <div className="text-md-end mt-2 mt-md-0">
                                            <div className="small text-muted mb-1">
                                                {/* Status: {field.status || 'pending'} */}
                                            </div>
                                            <div className="fw-normal">
                                                Value:{' '}
                                                {renderFieldValue(field)}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* If no fields exist */}
                        {(!pageItem?.usertodo?.fields || pageItem?.usertodo?.fields.length === 0) && (
                            <div className="text-muted small">
                                No field data available for this todo.
                            </div>
                        )}
                    </>
                ) : (
                    <div className="text-center text-muted">No data to display.</div>
                )}
            </div>
            <div className="row paddingtopbtm">
                <div className="col-md-5">
                    <button
                        type="submit"
                        className="btn save-btn savebtn"
                        onClick={onClose}
                    >
                        BACK
                    </button>
                </div>
                {pageItem.status === 1 ? (
                    <>
                        <div className="col-md-3">
                            <button
                                type="submit"
                                className="btn save-btn deny"
                                onClick={() => setShowApprove(true)}
                            >
                                DENY
                            </button>
                        </div>
                        <Deletemodel
                            message="Are you sure you want to deny?"
                            addModalShow={showApprove}
                            addModalClose={() => setShowApprove(false)}
                            confirmModal={handleSubmit}
                        />

                        <div className="col-md-4">
                            <button
                                type="submit"
                                className="btn save-btn allow"
                                onClick={() => setConfirmShow(true)}
                            >
                                APPROVE
                            </button>
                        </div>
                        <Confirmmodel
                            message="Are you sure you want to allow this ammendment?"
                            addModalShow={confirmshow}
                            addModalClose={() => setConfirmShow(false)}
                            confirmModal={handleSubmit}
                        />
                    </>
                ) : (
                    <div className="col-md-7 save-btn ">
                        <h6 className="alignright">
                            {pageItem.status === 2
                                ? "Verified"
                                : pageItem.status === 3
                                    ? "Denied"
                                    : "-"}
                        </h6>
                        <div className="text-xs alignright">
                            <TimeFormat time={pageItem.updatedAt} />
                        </div>
                    </div>
                )}
            </div>
        </Modal>
    );
}
